export type WebTVDetector = {
  id: string;
  vendor?: string | null;
  osName?: string | null;
  regex: RegExp;
  apiAvailable: () => boolean;
};

export const WEB_TV_DETECTORS: WebTVDetector[] = [
  {
    id: 'tizen',
    vendor: 'Samsung',
    osName: 'Tizen',
    regex: /Tizen/i,
    apiAvailable: () =>
      typeof window !== 'undefined' && ((window as any).tizen || (window as any).webapis),
  },
  {
    id: 'webos',
    vendor: 'LG',
    osName: 'webOS',
    regex: /Web[O0]S|LG Browser/i,
    apiAvailable: () =>
      typeof window !== 'undefined' &&
      ((window as any).webOS || (window as any).webOSDev || (window as any).webOSSystem),
  },
  {
    id: 'kepler',
    vendor: 'Amazon',
    osName: 'Vega OS',
    regex: /Kepler|Vega\s?OS|AFT[A-Z0-9]+/i,
    apiAvailable: () => false,
  },
];
